<template>
  <div>
    <div class="modal fade select-date-modal" id="show-image-modal" aria-hidden="true"
         aria-labelledby="exampleGrid" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-simple modal-lg">
        <div class="modal-content" style="display: block;">
          <div class="modal-header">
            <div class="container">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="$emit('closeImageModal')">
                <span aria-hidden="true" class="close-btn">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body mb-15">
            <img :src="file.name" width="100%" id="modal-image" alt="">
          </div>
          <v-loading :isLoading="smallLoading" :height="50" :width="50" :viewbox="'0 0 50 50'"
                     :cx="25" :cy="25" :r="22" :isHeightAuto="true"></v-loading>

          <div class="modal-footer d-flex justify-content-center mt-20">
            <button type="button" class="btn waves-effect waves-classic btn-cancel" @click.prevent="$emit('closeImageModal')"
                    data-dismiss="modal">{{ $t("button.close") }}
            </button>
            <button
              type="submit"
              class="btn btn-primary waves-effect waves-classic btn-save"
              @click.prevent="downloadCheckListFile"
              :disabled="smallLoading"
            >
              {{$t("button.download")}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mixin from "../../../../mixins/mixin";
  import checkListGroupService from '../../../../services/checklist_group';

    export default {
        name: "ViewCheckListMultimedia",
        data() {
          return {
            smallLoading: false
          }
        },
        props: [
          'file'
        ],
        components: {
          VLoading : require('components/loading/loading.vue'),
        },
        mixins: [mixin],
        methods: {
          async downloadCheckListFile() {
            this.smallLoading = true;
            await checkListGroupService.downloadMultimedia(this, this.file);
          }
        }
    }
</script>



// WEBPACK FOOTER //
// ViewCheckListMultimedia.vue?917f582c